(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("vector-source", [], factory);
	else if(typeof exports === 'object')
		exports["vector-source"] = factory();
	else
		root["vector-source"] = factory();
})(self, function() {
return 